/**
 * 侧栏插件导航：读取 `plugin-store` 中由已激活插件注册的 `route` 条目，
 * 渲染「插件」分组下的链接列表，指向 `PluginRoutePage` 对应路由并与当前路径高亮联动。
 */
import { useMemo } from "react";
import { Link, useLocation } from "react-router";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/shared/ui/sidebar";

import { PluginIcon } from "./plugin-icon";
import { usePluginStore } from "../state/plugin-store";

export function SidebarPlugins(): React.ReactElement | null {
  const routeEntries = usePluginStore((s) => s.routeEntries);
  const location = useLocation();

  const entries = useMemo(() => Array.from(routeEntries.values()), [routeEntries]);

  if (entries.length === 0) return null;

  return (
    <SidebarGroup>
      <SidebarGroupLabel>插件</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {entries.map((entry) => {
            const url = `/mine/plugins/${entry.pluginId}`;
            const isActive = location.pathname === url;
            return (
              <SidebarMenuItem key={entry.pluginId}>
                <SidebarMenuButton asChild tooltip={entry.title} isActive={isActive}>
                  <Link to={url}>
                    <PluginIcon name={entry.icon} />
                    <span>{entry.title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
